import React, { Component } from 'react'
import { Tabs, Row, Col, Form, Input, Button, Spin, Icon, Tooltip, Progress, InputNumber, Upload, message, Modal, Tag, notification, Select } from 'antd';
// import CKEditor from '@ckeditor/ckeditor5-react';
import CKEditor from 'ckeditor4-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { connect } from 'react-redux';
import { uploadPost } from '../../../../core/actions/uploadPost';
import { getPostCats } from '../../../../core/actions/postGet';
import { bindActionCreators } from "redux"
import { gcsKeys, config, CLOUD_FUNCTION } from '../../../../../config/fbConfig'
const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const antIcon = <Icon type="loading" style={{ fontSize: 50 }} spin />

const openNotificationWithIcon = (type, msg, desc) => {
  notification[type]({
    message: msg,
    description: desc,
  });
};

class PostForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList: [],
      // tags: [],
      inputVisible: false,
      inputValue: '',
      title: '',
      content: '',
      readTime: '',
      postGoAhead: true,
      isImage: true,
      author: '',
      loading: false,
      postCat: [],
      postcats: [],
      asDraft: false
    }

    // this.beforeUpload = this.beforeUpload.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleSelectChange(value) {
    this.setState({ postCat: value });
  }

  handleClose = removedTag => {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    console.log(tags);
    this.setState({ tags });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, inputValue];
    }
    this.setState({
      tags,
      inputVisible: false,
      inputValue: '',
    });
  };

  saveInputRef = input => (this.input = input);

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  // beforeUpload(file) {
  //   const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
  //   this.setState({ isImage });
  //   if (!isImage) {
  //     message.error('You can only upload JPEG & PNG file!');
  //     this.setState({
  //       fileList: []
  //     })
  //   }
  //   return isImage;
  // }

  dataForImaage = (file) => {
    return {
      projectId: config.projectId,
      destination: `images/${this.props.profile.uid}/${file.name}`
    }
  }

  handleChangeImg = ({ fileList, file }) => {
    const { status } = file;
    if (status === 'done') {
      var { mediaLink } = file.response;
      fileList[0].thumbUrl = mediaLink
      this.setState({ fileList });

    }
    else this.setState({ fileList });
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmitAsDraft = (e) => {
    e.preventDefault()
    const { fileList, tags, content, postGoAhead } = this.state
    if (fileList.length === 0) {
      message.error('Please upload post image');
      this.setState({
        postGoAhead: false
      })
    } else {
      this.setState({
        postGoAhead: true
      })
    }
    // if (tags.length === 0) {
    //   message.error('Please upload post tag(s)');
    //   this.setState({
    //     postGoAhead: false
    //   })
    // } else {
    //   this.setState({
    //     postGoAhead: true
    //   })
    // }
    if (content.length === 0) {
      message.error('Please add a content to this post');
      this.setState({
        postGoAhead: false
      })
    } else {
      this.setState({
        postGoAhead: true
      })
    }
    this.props.form.validateFields((err) => {
      if (!err && postGoAhead) {
        // console.log(this.state)
        this.setState({
          asDraft: true
        }, () => {
          this.props.uploadPost(this.state)
        })
      }
    });
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { fileList, tags, content, postGoAhead } = this.state
    if (fileList.length === 0) {
      message.error('Please upload post image');
      this.setState({
        postGoAhead: false
      })
    } else {
      this.setState({
        postGoAhead: true
      })
    }
    // if (tags.length === 0) {
    //   message.error('Please upload post tag(s)');
    //   this.setState({
    //     postGoAhead: false
    //   })
    // } else {
    //   this.setState({
    //     postGoAhead: true
    //   })
    // }
    if (content.length === 0) {
      message.error('Please add a content to this post');
      this.setState({
        postGoAhead: false
      })
    } else {
      this.setState({
        postGoAhead: true
      })
    }
    this.props.form.validateFields((err) => {
      if (!err && postGoAhead) {
        // console.log(this.state)
        this.setState({
          asDraft: false
        }, () => {
          this.props.uploadPost(this.state)
        })
      }
    });
  }

  componentDidMount() {
    const { postcats } = this.state;
    if (!postcats.length) {
      this.props.getPostCats();
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    const { profile, post, postcats } = nextProps
    this.setState({
      author: profile,
      loading: post.loading,
      postcats
    })
    if (post.uploadSuccess) {
      openNotificationWithIcon('success', 'Post Created!', post.uploadSuccess)
      this.props.form.resetFields()
      this.setState({
        fileList: [],
        tags: [],
        content: ''
      })
      post.uploadSuccess = null
    }
    if (post.uploadError) {
      openNotificationWithIcon('error', 'Post Failed!', post.uploadError)
      post.uploadError = null
    }
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    const { previewVisible, previewImage, fileList, tags, inputVisible, inputValue, loading, content, postcats } = this.state;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <div className="cpost-form">
        <Spin spinning={loading} indicator={antIcon} tip="Creating post...">
          <Form className="" onSubmit={this.handleSubmit}>
            <Form.Item label="Post Title">
              {getFieldDecorator('title', {
                rules: [{ required: true, message: 'Please input post title' }]
              })(
                <Input
                  name="title"
                  placeholder="Post Title"
                  onChange={(e) => this.handleChange(e)}

                />
              )}
            </Form.Item>
            <Form.Item label="Read time in minutes">
              {getFieldDecorator('readtime', {
                rules: [{ required: true, message: 'Please input read time' }]
              })(
                <Input
                  name="readTime"
                  type="number"
                  placeholder="Read Time"
                  min="1"
                  onChange={(e) => this.handleChange(e)}
                />
              )}
            </Form.Item>
            <Form.Item label="Chose Category">
              {getFieldDecorator('select', {
                rules: [
                  { required: true, message: 'Please select a category' }
                ]
              })(
                <Select mode="multiple" onChange={this.handleSelectChange} placeholder="Chose Category">
                  {
                    postcats.map((postcat) => (
                      <Option value={postcat.slug} key={postcat.id}>{postcat.slug}</Option>
                    ))
                  }
                  {/* <Option value="student">Student</Option> */}
                </Select>
              )}
            </Form.Item>
            {/* <Form.Item label="Post Tags">
              {tags.map((tag, index) => {
                const isLongTag = tag.length > 20;
                const tagElem = (
                  <Tag key={tag} closable onClose={() => this.handleClose(tag)}>
                    {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                  </Tag>
                );
                return isLongTag ? (
                  <Tooltip title={tag} key={tag}>
                    {tagElem}
                  </Tooltip>
                ) : (
                    tagElem
                  );
              })}
              {inputVisible && (
                <Input
                  ref={this.saveInputRef}
                  type="text"
                  size="small"
                  style={{ width: 78 }}
                  value={inputValue}
                  onChange={this.handleInputChange}
                  onBlur={this.handleInputConfirm}
                  onPressEnter={this.handleInputConfirm}
                />
              )}
              {!inputVisible && (
                <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
                  <Icon type="plus" /> New Tag
                </Tag>
              )}
            </Form.Item> */}
            <Form.Item label="Post Image">
              <div className="clearfix">
                <Upload
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  action='https://orsityfileserver.herokuapp.com/fileupload'
                  accept="image/*"
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={this.handlePreview}
                  onChange={this.handleChangeImg}
                  data={this.dataForImaage}
                // beforeUpload={this.beforeUpload}
                >
                  {fileList.length === 1 ? null : uploadButton}
                </Upload>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                  <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
              </div>
            </Form.Item>
            <Form.Item label="Post Content" />
            <CKEditor
              data={content}
              onChange={(evt) => {
                this.setState( {
                  content: evt.editor.getData()
                }, ()=>{
                  // console.log(this.state.content)
                });
              }}
            />
            <Form.Item>
              <Button type="primary" htmlType="submit" className="save-btn">
                Publish
              </Button>
              <Button className="draft-btn" onClick={this.handleSubmitAsDraft}>
                Save as Draft
              </Button>
            </Form.Item>
          </Form>
        </Spin>

      </div>
    )
  }
}

const WrappedPostForm = Form.create()(PostForm);

const mapStateToProps = state => ({
  profile: state.firebase.profile,
  post: state.post,
  postcats: state.allPosts.postcats
})

const mapDispatchToProps = dispatch => bindActionCreators({
  uploadPost,
  getPostCats
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedPostForm);
